/*
import React, {useState} from 'react';

export default function VerifiedDomainsAddDomain({server, pageData}) {

    let [data, setData] = useState(pageData);

	return (
        <>
		This is /user/verified-domains/add-domain?domain=zzz.com route
        </>
    )
}

*/


import React, {useEffect,useState, useReducer} from 'react';
import  {useRef} from 'react';
import {Buffer} from 'buffer';
import {Link} from "react-router-dom";
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import {getDomain} from '../../helpers/helpers.js'
import useGoogleCaptcha from '../../components/useReCaptcha.js';

import {RtApiResult, RtAddVerifiedDomainPageResult} from '../../../../server/routes/user.js'
import { APIResponse } from '../../../../server/routes/route-types.js';


// Interface for component props
interface VerifiedDomainsAddDomainProps {
    server: string;
    pageData: unknown;
}

// Interface for add verified form props
interface AddVerifiedFormProps {
    reCaptchaSiteKey: string;
    props: RtAddVerifiedDomainPageResult;
    google: wts_approved_any;
}

export default function VerifiedDomainsAddDomain({server, pageData}: VerifiedDomainsAddDomainProps) {

    let [data, setData] = useState(pageData as RtAddVerifiedDomainPageResult);

    const google = useGoogleCaptcha();

    return (
        <>
             <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-9 col-lg-9 col-xl-9">
                        <h3 style={{wordWrap: 'break-word'}}>Verify Domain Ownership</h3>
                        <p>
                        To perform security scans and ongoing monitoring, users must verify domain ownership. 
                        The simplest way to do this is by registering an account using an email address associated with the domain. 
                        Alternatively, you can verify ownership by uploading a text file containing a verification code to your website.                            
                        </p>
                        <p>
                        Please use the form below to generate your verification code and complete the domain ownership verification process. 
                        </p>
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-9 col-lg-9 col-xl-9">
                            <AddVerifiedForm   props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey} 
                                google={google}/> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </>
    )
}

function AddVerifiedForm({reCaptchaSiteKey, props, google}: AddVerifiedFormProps) {

    const domain = props.Domain;
    const initialFlashProps: FlashMessageData = {
        errors: props.errors,
        success_msg: props.success_msg,
        error_msg: props.error_msg,
        error: props.error
    }

    const [flashProps, setFlashProps] = useState(initialFlashProps);

    useEffect(() => { 
        return () => {
            let script = document.getElementById('googleCaptchaScript');
            if (script) {
                script.remove();
            }
        }				
    },[google])       
  
    let domainControl = useRef<HTMLInputElement>(null);
    let codeControl = useRef<HTMLInputElement>(null);
    let clipboardControl = useRef<HTMLSpanElement>(null);
    let locationControl = useRef<HTMLInputElement>(null);  
  
    function getDomain(website: string): string {
        if (website && website.length > 0) {
            var regExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)(?:.*)?$/g;
            var match = regExp.exec(website.trim());
            if (match !== null) {
                return  match[1];;
            }
        }
        return '';
    }
    function generateVerificationCode(website: string): string {
        const domain = getDomain(website);
        if (domain.length) {
            return Buffer.from(domain).toString('base64');
        }
        return '';
    }
    function generateVerificationUrl(website: string): string {
        const domain = getDomain(website);
        if (domain.length) {
            return "https://" + domain + "/wts.txt";       
        }
        return '';
    }
    function generateCode(): void {
        let domain = domainControl.current?.value || '';
        if (domain && domain.length > 0) {
            var regExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)(?:.*)?$/g;
            var match = regExp.exec(domain.trim());
            if (match !== null) {
                domain = match[1];
                let buff = Buffer.from(domain).toString('base64')
                console.log(buff);
                if (codeControl.current) codeControl.current.value = buff;
                if (locationControl.current) locationControl.current.value = "https://" + domain + "/wts.txt";                
                $("span").css("pointer-events", "auto");
                $("span").css("color", "black");
            } else {
                if (codeControl.current) codeControl.current.value = '';  
                if (locationControl.current) locationControl.current.value = '';   
                $("span").css("pointer-events", "none");
                $("span").css("color", "gray");
            }
        } else {
            if (codeControl.current) codeControl.current.value = '';
            if (locationControl.current) locationControl.current.value = '';      
            $("span").css("pointer-events", "none");
            $("span").css("color", "gray");
        }  
    }
    function clickEye(): void {
        if (codeControl.current) {
            navigator.clipboard.writeText(codeControl.current.value);
        }
    }
    function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        const captcha = grecaptcha.getResponse(); 
        const form = event.currentTarget;
        const domainElement = form.elements.namedItem('domain') as HTMLInputElement;
        let domain = getDomain(domainElement.value);
//        const permissionToScan = event.currentTarget.elements.permissionToScan.checked;
//        const technology = event.currentTarget.elements.technology.checked;
//        const security = event.currentTarget.elements.security.checked;

        setFlashProps({})

        console.log('domain='+domain);

        if (domain != undefined) {
            domain = domain.trim();
        }
    
    
        fetch( `/user/verified-domains/api-add-domain`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                domain:domain,
                captcha: captcha})
        }).then((response: Response) => {
            return response.json();
        }).then((untypedData: unknown) => {

            const data = untypedData as APIResponse<RtApiResult>;

            console.log('response'+data);

            if (data.err) {
                setFlashProps({error_msg: data.err})
            }
            else
            {
                if (data.results?.success_msg != undefined && data.results.success_msg.length > 0) {
                    setFlashProps({success_msg: data.results.success_msg} );
                                            /*
                    setTimeout(() => {

                        if (data.results?.Domain) {
                            window.location = "/user/verified-domains";                            
                        }
                            
                    }, 2000 );
                    */
                    if (grecaptcha) {
                        // reset captch to  allow 2nd submission
                        grecaptcha.reset();
                    }
                } else {
                    setFlashProps({error_msg: 'Unexpected error'})
                }
            }
        }).catch((e: unknown) => {
            setFlashProps({error: 'Unexpected client error'});
        });
      }
    return (      
        <>    
        <form action="/" method="POST" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            <div className="form-group">
            <input
                    type="domain"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Domain"
                    placeholder="Input the domain name"
                    required
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => generateCode()}
                    defaultValue={domain}
                    ref={domainControl}
                />                
            </div>          
            <div className="form-group">
                <label htmlFor="code">Verification code to paste in <i>wts.txt</i> text file</label>
                <div className="wts-pass-show">               
                    <input
                        type="text"
                        readOnly
                        id="code"
                        name="code"
                        className="form-control"
                        aria-label="Verification Code"
                        placeholder="Verification Code"
                        defaultValue={generateVerificationCode(domain!)}
                        ref={codeControl}
                    />   
                    <span className="wts-pass-text" ref={clipboardControl}
                        style={ domain && domain.length ? { pointerEvents: 'auto', color: 'black'} : { pointerEvents: 'none', color: 'gray'}}>
                        <i                  
                            onClick={(e: React.MouseEvent) => clickEye()}
                            className="mdi mdi-content-copy" 
                            aria-disabled="true"
                        />
                    </span>   
                </div>                         
            </div>  
            <div className="form-group">
            <label htmlFor="locationUri">Text file location on your website we'll use for domain ownership validation</label>
            <input
                    type="text"
                    readOnly
                    id="locationUri"
                    className="form-control"
                    aria-label="Location URI"
                    placeholder="Location URI"
                    ref={locationControl}
                    defaultValue={generateVerificationUrl(domain!)}
                />                
            </div>
            <div className="form-group" style={{ display: "flex" }}>
                            <div style={{ marginLeft: 'auto'}}
                                className="g-recaptcha" 
                                id="captcha1"
                                data-sitekey={reCaptchaSiteKey}>
                            </div>
            </div>   
            <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Verify Domain</button>
            </div>
            <div className="form-group" style={{ display: "flex" }}>
                <Link 
                    className="btn btn-primary" 
                    title='Monitored Websites list'
                    style={{ marginLeft: "auto" }} 
                to={'/user/verified-domains'}
                >
                    Verified domains list
            </Link>				
            </div>
        </form>        
    </>
   )
}


